import React, { memo, useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'
import { verifyAndSetToken } from '../utils'

const withToken = (Component) => {
  return memo(({ props }) => {
    const [loading, setLoading] = useState(false)

    useEffect(() => {
      verifyAndSetToken(() => setLoading(true))
    }, [])

    if (loading) {
      return (
        <Grid container justify="center">
          <Grid item>
            <CircularProgress size={32} color="inherit" />
          </Grid>
        </Grid>
      )
    }

    return <Component {...props} />
  })
}

export default withToken
